import React from 'react';
import { useLocale } from '../../../contexts/LocaleContext.jsx';

/** "● LIVE · 1,204 watching" pill (Figma StatusPill). Falls back to an outlined OFFLINE pill. */
const HomeStatusPill = ({ isLive = false, viewerCount = 0 }) => {
  const { t, format } = useLocale();
  if (!isLive) {
    return (
      <span className="listener-home-status-pill listener-home-status-pill--offline">
        <span className="listener-home-status-pill-label">{t('common.status.offline')}</span>
      </span>
    );
  }
  // A finite count keeps the plural lookup on `_one` / `_other`.
  const viewers = Number(viewerCount) || 0;
  return (
    <span className="listener-home-status-pill listener-home-status-pill--live">
      <span className="listener-home-status-pill-dot" aria-hidden="true" />
      <span className="listener-home-status-pill-label">{t('common.status.live')}</span>
      <span className="listener-home-status-pill-meta">
        {t('home.statusPill.watching', { count: viewers, viewers: format.number(viewers) })}
      </span>
    </span>
  );
};

export default HomeStatusPill;
